import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  PLATFORM_ID,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookieConsentService } from './cookie-consent.service';

@Component({
  selector: 'ess-root',
  template: `<router-outlet />`,
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RootComponent {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly cookieConsent = inject(CookieConsentService);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      void this.cookieConsent.activateCookieConsent();
    }
  }
}
